import $ from 'jquery'
import algoliasearch from 'algoliasearch/lite'
import instantsearch from 'instantsearch.js'
import { configure, index } from 'instantsearch.js/es/widgets'
import { connectSearchBox, connectHits } from 'instantsearch.js/es/connectors'
import autocompleteHit from '../components/autocompleteHit'
import autocompleteFaqHit from '../components/autocompleteFaqHit'
import autocompleteHits from '../components/autocompleteHits'
import searchBox from '../components/searchBox'
import {
  algoliaAppId,
  algoliaApiKey,
  recipeSearchIndex,
  faqSearchIndex,
  productSearchIndex,
} from '../variables'

// eslint-disable-next-line no-undef
const object = vnObject

// eslint-disable-next-line no-undef
const { __ } = wp.i18n

let autocompleteSearch
const checkEl = document.querySelector('.part-algolia-autocomplete')
if (checkEl) {
  const searchClient = algoliasearch(algoliaAppId, algoliaApiKey)
  const customHits = connectHits(autocompleteHits(autocompleteHit))
  const customFaqHits = connectHits(autocompleteHits(autocompleteFaqHit))

  autocompleteSearch = instantsearch({
    indexName: productSearchIndex,
    searchClient,
    insights: true,
  })

  const customSearchBox = connectSearchBox(searchBox)

  autocompleteSearch.addWidgets([
    customSearchBox({
      container: document.querySelector('.algolia-autocomplete-input-handler'),
      placeholder: __('Search...', 'vn'),
    }),

    customHits({
      container: document.querySelector(
        '.algolia-autocomplete-products-handler'
      ),
    }),

    configure({
      hitsPerPage: 5,
    }),

    index({ indexName: recipeSearchIndex }).addWidgets([
      configure({
        hitsPerPage: 5,
      }),

      customHits({
        container: document.querySelector(
          '.algolia-autocomplete-recipes-handler'
        ),
      }),
    ]),

    index({ indexName: faqSearchIndex }).addWidgets([
      configure({
        hitsPerPage: 5,
      }),

      customFaqHits({
        container: document.querySelector('.algolia-autocomplete-faq-handler'),
      }),
    ]),
  ])

  autocompleteSearch.start()
}

$(document).on(
  'keyup',
  '.part-algolia-autocomplete input[type="search"]',
  function () {
    const val = $(this).val()

    const permalinks = $('.part-algolia-autocomplete').find(
      '.algolia-autocomplete__discover'
    )

    permalinks.each(function () {
      const href = $(this).attr('data-original-url')

      if (!val) {
        $(this).attr('href', href)
      } else {
        const searchKeyword = object.searchPermalink
        $(this).attr('href', `${href}${searchKeyword}/${val}`)
      }
    })
  }
)
